module.exports = __webpack_public_path__ + "static/media/portfolio.44535b7f.png";